<div class="flex min-w-16 items-center justify-center">
  <span class="text-xs text-gray-400">{{ columnHeader() }}</span>
  @if (!readonly() && canRemove()) {
    <button
      (click)="remove.emit()"
      palantirTooltip="Remover coluna"
      [palantirTooltipDelay]="300"
      type="button"
      class="absolute right-1 top-1/2 -translate-y-1/2 rounded-full p-1 text-gray-400 opacity-0 transition-opacity hover:bg-gray-200 hover:text-red-500 group-hover:opacity-100"
    >
      <palantir-icon name="delete-outline" class="h-4 w-4"></palantir-icon>
    </button>
  }
</div>
